import { connect } from 'react-redux';
import { VehicleAttributesSection } from '@mitchell/react.component.ux';
import { TranslationService } from "../../common";
import { getVehicleData, vehicleChangeStateAction } from "../../vehicle";
import { getVehicleConfigurationAttributesByType, getInProgressStatus, VehicleConfigurationAttributesType, AttributeKeyForVehicle } from "../../vehicleConfigurationAttributes";
const mapStateToProps = (state) => {
    const vehicleData = getVehicleData(state);
    return {
        vehicleAttributes: {
            pinAttributes: getVehicleConfigurationAttributesByType(state, VehicleConfigurationAttributesType.PIN_ATTRIBUTES),
            nadaAttributes: getVehicleConfigurationAttributesByType(state, VehicleConfigurationAttributesType.NADA_ATTRIBUTES),
            redbookAttributes: getVehicleConfigurationAttributesByType(state, VehicleConfigurationAttributesType.REDBOOK_ATTRIBUTES)
        },
        selectedPinVid: vehicleData.pinVid || null,
        selectedNadaVid: vehicleData.nadaVid || null,
        selectedControlNumber: vehicleData.redbookControlNumber || null,
        isBusy: getInProgressStatus(state),
        translateFn: TranslationService.translate
    };
};
const mapDispatchToProps = (dispatch) => ({ dispatch });
const mergeProps = (stateProps, dispatchProps) => {
    return Object.assign(Object.assign({}, stateProps), { onAttributeChange: (name, value) => {
            const vehicleChangeItems = [{ name, value }];
            let selectedPin = {};
            stateProps.vehicleAttributes.pinAttributes.findIndex(pin => {
                if (pin.pinVid === value) {
                    selectedPin = pin;
                }
            });
            Object.keys(selectedPin).forEach(k => {
                if (k == AttributeKeyForVehicle.STYLE_ID || k == AttributeKeyForVehicle.SOURCE_VID) {
                    vehicleChangeItems.push({ name: k, value: selectedPin[k] });
                }
            });
            dispatchProps.dispatch(vehicleChangeStateAction({ items: vehicleChangeItems }));
        } });
};
export const VehicleAttributeContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(VehicleAttributesSection);
//# sourceMappingURL=VehicleAttributeContainer.js.map